import { fonts } from '~/src/helpers/font';
import { EElementType, ILandingElement } from '~/src/services/projects';

export const CarouselImage : ILandingElement = {
    title: 'CarouselImage',
    type: EElementType.CarouselImage,
    label: 'Изображение карусели',
    children: [
        {
            title: 'Image',
            type: EElementType.Image,
            label: 'Изображение',
            properties: {
                isActive: true,
                content: '',
                webp: '',
                alt: '',
                customStyles: '',
            },
        },
    ],
    properties: {
        customStyles: '',
        content: '',
        fixedImages: true,
        sortOrder: '',
    },
};

export const Carousel : ILandingElement = {
    title: 'Carousel',
    type: EElementType.Block,
    label: 'Карусель изображений',
    children: [
        {
            title: 'Title',
            type: EElementType.RTE,
            label: 'Заголовок',
            properties: {
                customize: {
                    font: fonts.H2,
                    color: '#1A1A1A',
                    textAlign: 'left',
                    tag: '',
                },
                htmlContent: 'Заголовок',
                customStyles: 'white-space: pre-wrap;',
            },
        },
        {
            title: 'SubTitle',
            type: EElementType.RTE,
            label: 'Подзаголовок',
            properties: {
                customize: {
                    font: fonts.S,
                    color: '#656565',
                    textAlign: 'left',
                    tag: '',
                },
                htmlContent: 'Подзаголовок',
                customStyles: '',
            },
        },
        {
            title: 'Text',
            type: EElementType.RTE,
            label: 'Описание',
            properties: {
                customize: {
                    font: fonts.S,
                    color: '#656565',
                    textAlign: 'left',
                },
                htmlContent: 'Текст...',
                customStyles: '',
            },
        },
        {
            title: 'Button',
            type: EElementType.Button,
            label: 'Кнопка',
            properties: {
                customStyles: '',
                isTargetBlank: false,
            },
            children: [
                {
                    title: 'Text',
                    type: EElementType.Text,
                    label: 'Текст',
                    properties: {
                        customize: {
                            font: fonts.S,
                            color: '#FFF',
                            href: '',
                        },
                        content: '',
                        customStyles: '',
                    },
                },
            ],
        },
    ],
    properties: {
        blockName: '',
        customStyles: '',
        content: '',
        fixedImages: true,
        addElement: EElementType.CarouselImage,
        sortOrder: '',
        background: '',
        backgroundWebp: '',
        customize: {
            color: '#1A1A1A',
        },
        marginTop: '',
        marginBottom: '',
    },
};
